// extracted by mini-css-extract-plugin
export default {"wrapper":"hero_wrapper__FJg4T","title":"hero_title__-JVga","stress":"hero_stress__tFIgV","des":"hero_des__oqyrF"};